/* =================== MINHA CONTA =================== */
jQuery(document).ready(function ($) {
  // Abre o modal de recuperaçao de senha
  $(".link-rec").on("click", function (e) {
    e.preventDefault();
    closeModal("modal-login");
    openModal("modal-recuperacao");
  });

  // Abre o modal de cadastro
  $(".open-cadastro").on("click", function (e) {
    e.preventDefault();
    const tipo = $(this).data("tipo");
    if (tipo) {
      $("#login-tipo").val(tipo);
      $("#cadastro-tipo").val(tipo);
    }
    closeModal("modal-login");
    openModal("modal-cadastro");
  });

  // Abre o modal de login
  $(".open-login").on("click", function (e) {
    e.preventDefault();
    const tipo = $(this).data("tipo");
    if (tipo) {
      $("#login-tipo").val(tipo);
      $("#cadastro-tipo").val(tipo);
    }
    closeModal("modal-cadastro");
    openModal("modal-login");
  });

  // Exibe a confirmação ao clicar no botão de remover
  $(".btn-confirm").on("click", function (e) {
    e.preventDefault();
    var idRemove = $(this).data("id");
    $("#id_remove").val(idRemove);
    openModal("modal-confirm");
  });

  // Exibe a confirmação ao clicar no botão de cancelamento
  $(".btn-cancela").on("click", function (e) {
    e.preventDefault();
    var idCancela = $(this).data("id");
    var hash = $(this).data("hash");
    $("#id_cancela").val(idCancela);
    $("#hash").val(hash);
    openModal("modal-confirm-cancelamento");
  });

  // REMOVER PLANO
  var enviando_formulario = false;
  $("#form-remove-plano").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    var idRemove = $("#id_remove").val();

    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-confirm");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            $("#id_remove").val("");
            showAlert("Sucesso", "Plano removido com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        }
      });
    }
  });

  // CANCELA ASSINATURA
  var enviando_formulario = false;
  $("#form-cancela-assinatura").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    var idRemove = $("#id_cancela").val();
    var hash = $("#hash").val();

    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-confirm");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          closeModal('modal-confirm-cancelamento');
          if (data == "ok") {
            $("#id_cancela").val("");
            $("#hash").val("");
            showAlert("Sucesso", "Cancelamento da Assinatura enviado com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 3000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar o cancelamento.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        }
      });
    }
  });

  // Exibe/Oculta os campos da forma de pagamento escolhida
  $('input[name="forma-pagamento"]').on("change", function () {
    $(".forma-pag-content").slideUp();
    $(".forma-pag-content .campo").prop("disabled", true);
    $(".forma-pag-content .campo").prop("required", false);

    $('.forma-pag-content[data-forma="' + $(this).val() + '"]').slideDown();
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "disabled",
      false
    );
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "required",
      true
    );
  });
});
